// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { smoothScrolling, getIconPath, removeSessionStorage } from '@tcp/core/src/utils';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import { setContactFormValuesInSS } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import ErrorMessage from '@tcp/core/src/components/features/CnC/common/molecules/ErrorMessage';
import {
  getDynamicLabelValues,
  renderLabel,
  getLabelFromCopyOrFromTranslation,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
} from '@tcp/core/src/utils/labels/globalActions.labels';
import { CONTACT_FORM } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.constant';
import LoginSectionV1 from '../organism/LoginSection';
import LoginSectionV2 from '../organism/LoginSectionV2';
import PasswordRequirement from '../../ResetPassword/molecules/PasswordRequirement';

const isCheckoutFlow = (componentType) => componentType === 'loginV2';
// eslint-disable-next-line complexity
const LoginView = ({
  onSubmit,
  onEmailSubmit,
  loginErrorMessage,
  initialValues,
  showRecaptcha,
  resetLoginState,
  SubmitForgot,
  showNotification,
  successFullResetEmail,
  resetForm,
  resetForgotPasswordErrorResponse,
  openModal,
  currentForm,
  queryParams,
  setLoginModalMountState,
  variation,
  handleContinueAsGuest,
  userplccCardNumber,
  userplccCardId,
  isLoading,
  isRememberedUser,
  userName,
  openOverlay,
  onClose,
  closeModal,
  closeOverlay,
  isResetPassCodeValidationEnabled,
  fullPage,
  fullPageAuthEnabled,
  setUserEmailAddress,
  emailAddressFromSS,
  isExistingUserFromSS,
  showEmailRecaptcha,
  saveExistingUserResponse,
  existingUserResponse,
  routeForBagCheckout,
  totalRewards,
  totalPoints,
  componentType,
  trackAnalyticsPageView,
  rememberedEmail,
  trackAnalyticsClick,
  isLoginWithOTPEnabled,
  maskedPhoneNumber,
  setLoginSelectionOption,
  selectedPassResetOption,
  isShowPhoneLoginOption,
  isShowOTPInputScreen,
  onGenerateOTP,
  showPasswordScreen,
  isLoginWithEmailOTPEnabled,
  loginSelectedOption,
  isNewLoginScreen,
  isLoginModal,
  otpToken,
  clearCouponTTLData,
  fromGuestFav,
  isBonusPointsEventMessagingEnabled,
  bonusPointEventMessageValue,
  fromPlccICLogin,
  isPlccLoginLoading,
  isOTpScreenEnabled,
  setIsFromCreateAccount,
  setLoader,
  phoneNumberSS,
  sessionStorageUserInfo,
  isUnverifiedAccount,
  isOtpLimit,
  resetOtpLimit,
  setShowVerificationErrorAction,
  isLocked,
  resetIsLocked,
  phoneCountryCode,
  loginFlowUXEnhancementEnabled,
  showBriteError,
  setShowBriteErrorMessage,
  briteErrorMessage,
  setBriteErrorMessageData,
  isBriteVerifyForLoginEnabled,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const { phoneCountryCode: phoneCountryCodeSS } = sessionStorageUserInfo || {};
  let LoginSection = LoginSectionV1;
  if (isCheckoutFlow(componentType)) {
    LoginSection = LoginSectionV2;
  }

  useEffect(() => {
    smoothScrolling('loginPage');
  }, []);

  useEffect(() => {
    if (isRememberedUser && !isCheckoutFlow(componentType)) {
      clearCouponTTLData();
    }
  }, [isRememberedUser]);

  const [errorMessageVisible, setErrorMessageVisible] = useState(true);

  const clickBackButton = (e) => {
    const { emailAddress, isExistingUser } = sessionStorageUserInfo || {};
    e.preventDefault();
    if (isBriteVerifyForLoginEnabled) {
      setShowBriteErrorMessage(false);
      setBriteErrorMessageData(false);
    }
    if (isShowOTPInputScreen) {
      showPasswordScreen();
      setErrorMessageVisible(false);
      setShowVerificationErrorAction(false);
    }
    if (isOTpScreenEnabled && !isShowOTPInputScreen) {
      resetLoginState();
      setContactFormValuesInSS();
      saveExistingUserResponse('');
      setErrorMessageVisible(false);
      setShowVerificationErrorAction(false);
      removeSessionStorage(CONTACT_FORM);
    }
    const onEmailFormScreen = isExistingUser && emailAddress;
    if (window.history && window.history.back && (!isOTpScreenEnabled || !onEmailFormScreen)) {
      window.history.back();
    }
  };

  const showBackButton = () => {
    const lefttarrow = getIconPath('toggle-left-arrow');
    const anchorStyle = { display: 'flex', alignItems: 'center', background: 'white' };
    return (
      <>
        <div className="back-button-otp-screen elem-pt-MED elem-pl-MED" style={anchorStyle}>
          <Image src={lefttarrow} onClick={clickBackButton} />
          <Anchor
            underline
            noLink
            fontFamily="secondary"
            fontSizeVariation="large"
            tag="span"
            fontSize="fs14"
            className="elem-ml-MED"
            onClick={clickBackButton}
          >
            {renderLabel(
              getLabelFromCopyOrFromTranslation(
                `${GLOBAL_ACTIONS_LABELS}.lbl_back`,
                GlobalActionsLabels
              ),
              'lbl_back'
            )}
          </Anchor>
        </div>
      </>
    );
  };

  const {
    vstatus: verificationStatus,
    otpLimit,
    locked,
    emailAddress,
    isCreateAccountOtpScreen,
  } = sessionStorageUserInfo || {};

  useEffect(() => {
    if (verificationStatus !== undefined) {
      setErrorMessageVisible(true);
    }
  }, [verificationStatus]);

  useEffect(() => {
    return () => {
      if (isBriteVerifyForLoginEnabled) {
        setShowBriteErrorMessage(false);
        setBriteErrorMessageData(false);
      }
    };
  }, []);

  const handleClose = () => {
    if (isBriteVerifyForLoginEnabled) {
      setShowBriteErrorMessage(false);
      setBriteErrorMessageData(false);
    }
    setErrorMessageVisible(false);
  };

  const showCreateAccOtpScreen = verificationStatus !== undefined && !verificationStatus;
  const showNotificationAndBackButton =
    ((!otpLimit && showCreateAccOtpScreen && !locked) || (isUnverifiedAccount && emailAddress)) &&
    isOTpScreenEnabled &&
    (emailAddress || existingUserResponse?.emailAddress);
  return (
    <div id="loginPage">
      <>
        {((isBriteVerifyForLoginEnabled && showBriteError) ||
          ((showNotificationAndBackButton ||
            (isCheckoutFlow(componentType) && isCreateAccountOtpScreen && emailAddress)) &&
            errorMessageVisible)) && (
          <ErrorMessage
            isCloseable
            error={
              isBriteVerifyForLoginEnabled && briteErrorMessage
                ? briteErrorMessage
                : getDynamicLabelValues('dynamic.account_d.lbl_email_verification_error')
            }
            spc
            fromLoginFlow
            handleClose={handleClose}
          />
        )}

        {!loginFlowUXEnhancementEnabled &&
          (showNotificationAndBackButton ||
            (isCheckoutFlow(componentType) && isCreateAccountOtpScreen && emailAddress)) &&
          showBackButton()}

        {loginFlowUXEnhancementEnabled && !fromPlccICLogin && showBackButton()}
      </>
      <LoginSection
        isLoading={isLoading}
        onSubmit={onSubmit}
        emailAddressFromSS={emailAddressFromSS}
        isExistingUserFromSS={isExistingUserFromSS}
        onEmailSubmit={onEmailSubmit}
        loginErrorMessage={loginErrorMessage}
        initialValues={initialValues}
        showRecaptcha={showRecaptcha}
        showEmailRecaptcha={showEmailRecaptcha}
        resetLoginState={resetLoginState}
        SubmitForgot={SubmitForgot}
        isRememberedUser={isRememberedUser}
        showNotification={showNotification}
        successFullResetEmail={successFullResetEmail}
        resetForm={resetForm}
        resetForgotPasswordErrorResponse={resetForgotPasswordErrorResponse}
        openModal={openModal}
        currentForm={currentForm}
        queryParams={queryParams}
        setLoginModalMountState={setLoginModalMountState}
        variation={variation}
        handleContinueAsGuest={handleContinueAsGuest}
        tooltipContent={<PasswordRequirement />}
        userplccCardNumber={userplccCardNumber}
        userplccCardId={userplccCardId}
        userName={userName}
        openOverlay={openOverlay}
        onClose={onClose}
        closeModal={closeModal}
        closeOverlay={closeOverlay}
        isResetPassCodeValidationEnabled={isResetPassCodeValidationEnabled}
        fullPage={fullPage}
        fullPageAuthEnabled={fullPageAuthEnabled}
        setUserEmailAddress={setUserEmailAddress}
        existingUserResponse={existingUserResponse || sessionStorageUserInfo}
        saveExistingUserResponse={saveExistingUserResponse}
        routeForBagCheckout={routeForBagCheckout}
        totalRewards={totalRewards}
        trackAnalyticsPageView={trackAnalyticsPageView}
        totalPoints={totalPoints}
        rememberedEmail={rememberedEmail}
        trackAnalyticsClick={trackAnalyticsClick}
        isLoginWithOTPEnabled={isLoginWithOTPEnabled}
        maskedPhoneNumber={maskedPhoneNumber || phoneNumberSS}
        setLoginSelectionOption={setLoginSelectionOption}
        selectedPassResetOption={selectedPassResetOption}
        isShowPhoneLoginOption={
          isShowPhoneLoginOption || sessionStorageUserInfo?.isShowPhoneLoginOption
        }
        isShowOTPInputScreen={isShowOTPInputScreen}
        onGenerateOTP={onGenerateOTP}
        showPasswordScreen={showPasswordScreen}
        isLoginWithEmailOTPEnabled={isLoginWithEmailOTPEnabled}
        loginSelectedOption={loginSelectedOption}
        isNewLoginScreen={isNewLoginScreen}
        isLoginModal={isLoginModal}
        otpToken={otpToken || sessionStorageUserInfo?.token}
        fromGuestFav={fromGuestFav}
        isBonusPointsEventMessagingEnabled={isBonusPointsEventMessagingEnabled}
        bonusPointEventMessageValue={bonusPointEventMessageValue}
        fromPlccICLogin={fromPlccICLogin}
        isPlccLoginLoading={isPlccLoginLoading}
        isOTpScreenEnabled={isOTpScreenEnabled}
        setIsFromCreateAccount={setIsFromCreateAccount}
        setLoader={setLoader}
        sessionStorageUserInfo={sessionStorageUserInfo}
        isUnverifiedAccount={isUnverifiedAccount}
        showNewOtpScreen={showCreateAccOtpScreen && !otpLimit && !locked}
        isOtpLimit={isOtpLimit}
        resetOtpLimit={resetOtpLimit}
        setShowVerificationErrorAction={setShowVerificationErrorAction}
        isLocked={isLocked}
        resetIsLocked={resetIsLocked}
        phoneCountryCode={phoneCountryCode || phoneCountryCodeSS}
        loginFlowUXEnhancementEnabled={loginFlowUXEnhancementEnabled}
        setShowBriteErrorMessage={setShowBriteErrorMessage}
        setBriteErrorMessageData={setBriteErrorMessageData}
        isBriteVerifyForLoginEnabled={isBriteVerifyForLoginEnabled}
      />
    </div>
  );
};

LoginView.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loginErrorMessage: PropTypes.string,
  initialValues: PropTypes.shape({}).isRequired,
  showRecaptcha: PropTypes.bool,
  resetForgotPasswordErrorResponse: PropTypes.bool.isRequired,
  resetForm: PropTypes.bool.isRequired,
  resetLoginState: PropTypes.bool.isRequired,
  SubmitForgot: PropTypes.bool.isRequired,
  showNotification: PropTypes.bool.isRequired,
  successFullResetEmail: PropTypes.bool.isRequired,
  openModal: PropTypes.func,
  currentForm: PropTypes.string.isRequired,
  queryParams: PropTypes.shape({}).isRequired,
  setLoginModalMountState: PropTypes.bool.isRequired,
  variation: PropTypes.bool.isRequired,
  handleContinueAsGuest: PropTypes.func.isRequired,
  userplccCardNumber: PropTypes.string.isRequired,
  userplccCardId: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isRememberedUser: PropTypes.bool,
  userName: PropTypes.string,
  onClose: PropTypes.func,
  openOverlay: PropTypes.func,
  closeModal: PropTypes.func,
  closeOverlay: PropTypes.func,
  isResetPassCodeValidationEnabled: PropTypes.bool,
  fullPage: PropTypes.bool,
  fullPageAuthEnabled: PropTypes.bool,
  showEmailRecaptcha: PropTypes.bool,
  emailAddressFromSS: PropTypes.string,
  trackAnalyticsClick: PropTypes.func,
  isLoginWithOTPEnabled: PropTypes.bool,
  maskedPhoneNumber: PropTypes.string,
  setLoginSelectionOption: PropTypes.func,
  selectedPassResetOption: PropTypes.string,
  isShowPhoneLoginOption: PropTypes.bool,
  isShowOTPInputScreen: PropTypes.bool,
  onGenerateOTP: PropTypes.func,
  showPasswordScreen: PropTypes.func,
};

LoginView.defaultProps = {
  loginErrorMessage: '',
  showRecaptcha: false,
  openModal: () => {},
  openOverlay: () => {},
  onClose: () => {},
  closeModal: () => {},
  isRememberedUser: false,
  userName: '',
  closeOverlay: () => {},
  isResetPassCodeValidationEnabled: false,
  fullPage: false,
  fullPageAuthEnabled: false,
  showEmailRecaptcha: false,
  emailAddressFromSS: '',
  trackAnalyticsClick: () => {},
  isLoginWithOTPEnabled: false,
  maskedPhoneNumber: '',
  setLoginSelectionOption: () => {},
  selectedPassResetOption: '',
  isShowPhoneLoginOption: false,
  isShowOTPInputScreen: false,
};

export default LoginView;
